import BaseModel from "./BaseModel";

/**
 * CertificateAsset 
 */
export default class CertificateAsset extends BaseModel{

  constructor({
    pdf_file,
    svg_file
  }) {
    super();

    this.pdf_file = pdf_file || null;
    this.svg_file = svg_file || null;
    
    this.parsed_files = {
      pdf: '',
      svg: ''
    }
  }

  /**
   * Generates the base64 values for files
   */
  async parseFiles() {
    if (this.pdf_file) {
      this.parsed_files.pdf = await this.blobToBase64(this.pdf_file, 'pdf');
    }

    if (this.svg_file) {
      this.parsed_files.svg = await this.blobToBase64(this.svg_file, 'svg');
    }
  }

  /**
   * Checks if there are files
   * @returns {boolean}
   */
  hasFiles() {
    return this.pdf_file && this.svg_file;
  }

  /**
   * Gets file
   * @param {string} target - either (pdf or svg)
   * @param {bool} asBlob - false = base64
   * @returns {string} 
   */
  getFile(target = 'pdf', asBlob = true) {
    if (!asBlob) {
      return this.parsed_files[target] != undefined ? this.parsed_files[target] : '';
    }

    let fileSource = (target === 'pdf') ? this.pdf_file : this.svg_file;
    return fileSource;
  }

  /**
   * Converte um Blob em uma String Base64
   * @param {Blob} blob 
   * @returns {Promise<string>}
   */
  blobToBase64(bufferObj, target = 'pdf') {
    return new Promise((resolve, reject) => {
      try {
        const binaryData = bufferObj.data ? bufferObj.data : bufferObj;
        const uint8Array = new Uint8Array(binaryData);
        
        const mimeType = target === 'pdf' ? 'application/pdf' : 'image/svg+xml';
        const blob = new Blob([uint8Array], { type: mimeType });

        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      } catch (e) {
        reject(e);
      }
    });
  }
}